import { ArticleParagraph3, UIText1 } from '@cian/ui-kit';
import * as React from 'react';
import { MortgageProgramDescription } from '../../../MortgageProgramDescription';
import * as styles from './ProgramContent.css';
import { IProgram } from '../../../../../../types/mortgage';

type TProgramContentProps = Pick<
  IProgram,
  'isUntilRate' | 'rate' | 'creditLimitMillions' | 'termYears' | 'description'
>;

export const ProgramContent: React.FC<TProgramContentProps> = ({
  isUntilRate,
  rate,
  creditLimitMillions,
  description,
  termYears,
}) => {
  return (
    <>
      <div className={styles['parameters']}>
        <div className={styles['header']}>
          {['Ставка', 'Сумма кредита', 'Срок'].map(header => (
            <ArticleParagraph3 color="gray60_100" key={header}>
              {header}
            </ArticleParagraph3>
          ))}
        </div>
        <div className={styles['row']}>
          <UIText1>
            {isUntilRate ? 'до' : 'от'} {rate}%
          </UIText1>
          <UIText1>до {creditLimitMillions} млн ₽</UIText1>
          <UIText1>до {termYears} лет</UIText1>
        </div>
      </div>
      <div className={styles['description']}>
        <MortgageProgramDescription description={description} />
      </div>
    </>
  );
};
